import { useTranslation } from "react-i18next";
import { Typography, keyframes } from "@mui/material";

const ThinkingMessage = () => {
  const { t } = useTranslation("gino", { keyPrefix: "component.thinkingMessage" });

  return <Typography sx={styles.typingEffect}>{t("thinking")}</Typography>;
};

export default ThinkingMessage;

const thinkingAnimation = keyframes`
  0%, 100% {
    color: var(--Gray---400, #A0A0A0);
  }
  50% {
    color: var(--Dark---1000, #111);
  }
`;

const styles = {
  typingEffect: {
    width: "fit-content",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "24px",
    borderRadius: "0 8px 8px 8px",
    border: "1px solid #E4E7EC",
    padding: "10px 14px",
    animation: `${thinkingAnimation} 1.5s ease-in-out infinite`,
  },
};
